export default __webpack_public_path__ + "static/media/react-native.55360266.svg";